import React, { Component } from "react";

const ChangePasswordConfirmation = () => {
    return (
      <section className="section auth">
        <div className="container">
          <h1>Change Password</h1>
          <p>Your password has been successfully updated!</p>
        </div>
      </section>
    );
}

export default ChangePasswordConfirmation;